// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IPLGl","type":"styles_type__3q4wl","choices":"styles_choices__3yJ-N"};